define('studio/laser-parse',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.reorder = exports.text2points = void 0;
    function text2points(text, metric) {
        return text
            .split("\n")
            .map(function (l) { return line2point(l, metric); })
            .filter(function (p) { return p !== undefined; });
    }
    exports.text2points = text2points;
    function line2point(line, metric) {
        line = line.trim();
        // Split on comma, or split on space
        var split = line.match(/[,/]/) ? line.split(/[,/]/) : line.split(/[ \t]+/);
        if (split.length !== 2) {
            return undefined;
        }
        var x = toNumber(split[0], metric);
        var y = toNumber(split[1], metric);
        if (isFinite(x) && isFinite(y)) {
            return { x: x, y: y };
        }
        else {
            return undefined;
        }
    }
    /**
     * Parse a number with units
     */
    function toNumber(str, metric) {
        if (str === "") {
            return NaN;
        }
        else if (str.endsWith("m")) {
            return Number(str.substring(0, str.length - 1));
        }
        else if (str.endsWith("ft")) {
            return Number(str.substring(0, str.length - 2)) * 0.3048;
        }
        else if (str.endsWith("yd")) {
            return Number(str.substring(0, str.length - 2)) * 0.9144;
        }
        else {
            // Use selected units
            var units = metric ? 1 : 0.3048;
            return Number(str) * units;
        }
    }
    /**
     * Reorder laser points to handle out-of-order and lasering from bottom.
     *
     * There are three laser input formats:
     * Quadrant 2: 20,-100
     * Quadrant 1: 20,100 (laser from bottom)
     * Quadrant 4: -100,20 (reversed y,x)
     */
    function reorder(points) {
        // Find height and width range
        var _a = extent(points, function (p) { return p.x; }), xMin = _a[0], xMax = _a[1];
        var _b = extent(points, function (p) { return p.y; }), yMin = _b[0], yMax = _b[1];
        // Check if reversible
        if (xMin < 0 && xMax <= 0 && yMin >= 0) {
            // Quadrant 4: Assume coordinates are reversed y,x
            return points
                .map(function (point) {
                // noinspection JSSuspiciousNameCombination
                return {
                    x: point.y,
                    y: point.x
                };
            });
        }
        else if (xMin >= 0 && yMin >= 0 && yMax > 0) {
            // Quadrant 1: Assume lasering from bottom
            var rev = points
                .map(function (point) {
                return {
                    x: xMax - point.x,
                    y: point.y - yMax
                };
            });
            // Add reversed 0,0
            rev.push({ x: xMax, y: -yMax });
            // Sort by horiz
            return rev.sort(function (l1, l2) { return l1.x - l2.x; });
        }
        else {
            // Quadrant 2: default x,y
            return points;
        }
    }
    exports.reorder = reorder;
    /**
     * Extent function like d3.extent
     */
    function extent(list, proj) {
        var min = Infinity;
        var max = -Infinity;
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var p = list_1[_i];
            var value = proj(p);
            if (value < min)
                min = value;
            if (value > max)
                max = value;
        }
        return [min, max];
    }
});
//# sourceMappingURL=/assets/javascripts/studio/laser-parse.js.map;
